import React, { useState } from "react";
import { Map, Marker, APIProvider} from "@vis.gl/react-google-maps";
import Address from "../types/Address";

const Mapscreen = ({origin}:{origin: Address}) => {
  // shows marker on London by default
  const [markerLocation, setMarkerLocation] = useState({
    lat: origin.lat,
    lng: origin.lng,
  });

  return (
    <div className="h-[300px] w-full">
        <APIProvider apiKey={process.env.REACT_APP_GOOGLE_API_KEY ?? ''}>      <Map
        style={{ borderRadius: "20px" }}
        defaultZoom={13}
        defaultCenter={markerLocation}
        gestureHandling={"greedy"}
        disableDefaultUI
      >
        <Marker position={markerLocation} />
      </Map></APIProvider>

    </div>
  );
}

export default Mapscreen;